<template>
         <div>
             <!-- <el-button style="width:150px" @click="selectGoods">选择商品</el-button> -->
             <el-dialog v-dialogDrag title="商品查询" :visible.sync="dialogGoods" width='60%'>
                <div class="boxGoods">
                   <el-select v-model="value" placeholder="请选择">
                      <el-option
                         v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
                      </el-option>
                   </el-select>
                   <div class="ImageLinks">
                      <div>商品名称：</div>
                      <el-input v-model="inputGoods" placeholder="请输入商品"></el-input>
                      <el-button @click="queryProduct(1)" class="inquire">查询</el-button>
                   </div>
                </div>
                <!-- 表格 -->
                <div class="rig_cont">
                   <el-table :data="tableData" border style="width: 100%" fit @selection-change="handleSelectionChange">
                      <el-table-column type="selection" width="55" align="center">
                      </el-table-column>
                      <el-table-column prop="rank_num" label="排序" width="55" align="center">
                      </el-table-column>
                      <el-table-column prop="name" label="产品名称" align="center">
                      </el-table-column>
                      <el-table-column prop="image" label="产品图片" align="center">
                         <template slot-scope="scope">
                            <el-image :src="scope.row.image" style="width: 45px; height: 45px;">
                            </el-image>
                         </template>
                      </el-table-column>
                      <el-table-column prop="spec" label="规格" align="center">
                      </el-table-column>
                      <el-table-column prop="mold" label="品种" align="center">
                      </el-table-column>
                      <el-table-column prop="base_price" label="基准价格" align="center">
                      </el-table-column>
                      <el-table-column prop="factory" label="产地" align="center">
                      </el-table-column>
                      <el-table-column prop="warehouse" label="仓库" align="center" :show-overflow-tooltip="true">
                      </el-table-column>
                      <el-table-column prop="stock" label="库存" align="center">
                      </el-table-column>
                      <el-table-column prop="allocated" label="已分配库存" align="center" width='100'>
                      </el-table-column>
                      <el-table-column prop="canstock" label="可用库存" align="center">
                      </el-table-column>
                      <el-table-column prop="sale_mode" label="销售状态" align="center">
                      </el-table-column>
                      <el-table-column prop="status" label="审核状态" align="center">
                      </el-table-column>
                   </el-table>
                </div>
                    <!-- 分页 -->
                <div class="block">
                   <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
                   :page-size="pageSize" layout="total, prev, pager, next, slot, jumper" :total="NumsPage">
                   <span slot style="width: 40px;color: dimgrey">
                      <label><input name="Fruit" type="checkbox" v-model="checked" @change="all" />显示全部</label>
                   </span>
                   </el-pagination>
                </div>
                <span slot="footer" class="dialog-footer">
               <el-button size="medium" type="primary" @click="confirmin" style="margin-right: 30px;">确定</el-button>
               <el-button size="medium"  @click="callOff">取消</el-button>
             </span>
             </el-dialog>
         </div>
 </template>
 <script>
    import {
       backbrary,
       updateadPlateinfo,
       uploadfile,
       scmfile,
       productputaway,
       getFilegroupview,
       CreateGroup,
       uploadPictures,
       showPictures,
       amendPictures,
       amendGroup,
       allPictures,
       advplateinfo 
    } from "../../static/API/API.js";
    export default {
      data() {
        return {
          isIndeterminate: true,
          // 分页总条数
          NumsPage:0,
          // 当前页
          currentPage1:1,
          pageSize:1,
       // 是否显示全部
         checked: false,
         checkedImg:false,
          // 表单
          tableData:[],
          // 年份
          year:['不限年份','2023','2022','2021','2020','2019','2018','2017','2016','2015','2014','2013','2012'],
          // 月份
          month:['不限月份','12','11','10','9','8','7','6','5','4','3','2','1'],
          options: [{
           value: '热销',
           label: '热销'
         },{
           value: '自营',
           label: '自营'
         }],
         value: '热销',
         yearData:'不限年份',
         monthData:'不限月份',
          //   设置按钮
          setBtn1:false,
          // 编辑按钮
          setBtn2:false,
          confirmBtn:'编辑',
          cancelBtn:'删除',
          // 图标切换
          el_icon_edit:'el-icon-edit',
          el_icon_delete:' el-icon-delete',
          //颜色切换
          edit_state:'#409eff',
          delete_state:'#cf1010 ',
          //文件夹名称
          filename:'',
          // 输入框切换
          edit1:true,
          FileGroupList:[],
          current:null,
          //页码
          pageNumber:1,
          // 页面容量
          PageSize:5,
          // 输入商品
          inputGoods:'',
          // 公司id
          firmId:'',
          listAll:'all',
          // 选择商品弹窗
          dialogGoods:false,
          // 文字标题
           txtTitle:'',
          // 文字链接、跳转链接
           titleLink:'',
          // 文字表单
         labelPosition: 'right',
         //向后端传递的图片接口
         uploadfile: uploadfile,
          // 选中图片的值
          checkedCities:[],
          // 图片库
          srcList: [],
          raylist:[],
          // 选中图片信息
          interlinkageLink: '',
          // 选中图片信息的数组
          boxImg:[],
          //图片序号
          serialNumber:'',
          // 图标标题
          serialTitle:'',
          // 图片库
          dialogImgregualte:false,
          // 图片库是编辑
          dialogImgregualteEdit:false,
          //分页和当前页
          currentPage0:20,
          currentPage2:1,
          pageSize2: 1,
          currentPage5:0,
          // 图片库点击事件的参数
          scmCompanyid2: '',
          userName2:'',
          // 图片库分页全选复选框
          checkedc: false,
          // 接收参数
          plateid: this.$route.query.platea, //板块id
          conteid: this.$route.query.contenid, //内容页id
          info_id: 0, //具体某一张图片的id，用于判断是否是编辑还是添加
          type: this.$route.query.type, //文字
           tophref: window.location.href
        };
      },
      mounted(){
    //    this.preserve()
       this.getfileData()
      },
      methods:{
       handleSelectionChange(val) {
        this.newData = val
        // this.dialogGoods = false
        //   let params = new URLSearchParams();
        //   params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
        //   params.append('AdPageId',this.conteid);//内容页id
        //   params.append('AdPlateId',this.plateid);//板块id
        //   params.append('ProductId',val[0].LOG_SPOT_SALE_PRODUCT_id_PK);//商品id
        //   params.append('Path',val[0].image);//图片路径
        //   params.append('SortNum',val[0].rank_num);//序号
        //   this.$axios.post(advplateinfo, params).then(res => {
        //      this.dialogGoods = false
        //      this.print()
        //   })
       },
       all(){
          if(this.checked){
             this.PageSize = 'all'
             this.queryProduct(1)
          }else{
             this.PageSize = 5
             this.queryProduct(1)
          }
       },
       // 改变当前所在页
       currentChangeHandle(val) {
         this.currentPage1 = val
         this.queryProduct(val)
       },
       // 点击查询按钮
       queryProduct(e){
          let params = new URLSearchParams();
          if(e){
             params.append('page_number',e);//页码
          }else{
             params.append('page_number',this.pageNumber);//页码
          }
          params.append('page_size',this.PageSize);//页面容量
          params.append('keyword',this.inputGoods == '' ? this.value : this.value + ' ' + this.inputGoods);//下拉
          params.append('companyid',this.firmId);//公司id(非必传)
          params.append('ope_type',this.listAll);
          this.$axios.get(productputaway,{
             params
          }).then(res =>{
          console.log(res.data[0],'查询产品');
          this.NumsPage = res.data[0].PageNums //分页总条数
          this.tableData = res.data[0].pagedata
          })
       },
       // 选择商品
       selectGoods(){
         this.dialogGoods = true
          // 查询产品
          this.queryProduct()
       },
       // 修改
       amend(e){
         console.log(e,'修改');
         let params = new URLSearchParams();
          params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
          params.append('AdPageId',this.conteid);//内容页id
          params.append('AdPlateId',this.plateid);//板块id
          params.append('Title',e.Title);//标题
          params.append('LinkUrl',e.LinkUrl);//标题链接
          params.append('SortNum',e.SortNum);//序号
          params.append('Path',e.Path);//图片路径
          params.append('info_id',e.Id);//广告详情页id
 
          // params.append('ProductId',this.currentPage0);//商品id
          // params.append('PlateInfoKey',this.currentPage0);//内容key
          // params.append('ActivityCreateTime',this.currentPage0);//开始时间
          // params.append('ActivityEndTime',this.currentPage0);//结束时间
          console.log(params);
          this.$axios.post(updateadPlateinfo, params).then(res => {
             this.$message({
                message: '修改成功！',
                type: 'success',
                duration: 1000,
             showClose: true,
             });
             this.print()
          })
       },
       // 删除
       Delete(e){
          let params = new URLSearchParams();
          params.append('info_id',e.Id);//广告详情页id
          this.$axios.get(updateadPlateinfo, {
             params
          }).then(res => {
             this.print()
             console.log(res,'删除');
          })
       },
       // 点击保存后调取图片内容接口
    //    print(){
    //       let params = new URLSearchParams();
    //       params.append('AdPlateId',this.plateid);//板块id
    //       this.$axios.get(advplateinfo,{
    //          params
    //       }).then(res =>{
    //          console.log(res.data.message);
    //          this.boxImg = res.data.message
    //          console.log(this.boxImg,'this.boxImg');
    //       })
    //    },
       // 上传图片成功组件
       handleAvatarSuccess(res, file, e) {
          console.log(res, file,e ,'上传图片成功组件');
       // 上传成功之后直接渲染
          e.Path = URL.createObjectURL(file.raw);
          e.Path = res
       },
       // 上传过程 上传后将本地图片传向后台，再返给前端图片链接
       beforeAvatarUpload(file) {
          console.log(file,'上传过程');
          let fd = new FormData();
          fd.append('file', file); //传文件
          this.$axios.post(uploadfile, fd).then(res =>{
             console.log(res.data,'上传图片后的返回');
             let params = new URLSearchParams();
             params.append('ope_type', '添加')
             params.append('link', res.data)
             params.append('companyid', sessionStorage.getItem('companyid'))
             params.append('up_user', sessionStorage.getItem('user_id'))
             this.$axios.post(scmfile, params).then(res=> {
                // this.$message({
                //    type: 'success',
                //    message: res.data
                // });
             })
          })
         const isJPG = file.type === 'image/jpeg';
         const isLt2M = file.size / 1024 / 1024 < 5;
          //   if (!isJPG) {
          //     this.$message.error('上传头像图片只能是 JPG 格式!');
          //   }
          //   if (!isLt2M) {
          //     this.$message.error('上传图片大小不能超过 2MB!');
          //   }
          //   return isJPG && isLt2M;
       },
       // 选中图片后的处理 点击选中图片后val拿到图片值，
       clicheck(val){
          this.checkedCities.push(val)
          this.pitchimg = val
          // console.log( this.checkedCities);
       //    this.interlinkageLink = val.link
       //    let params = new URLSearchParams();
       //    params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
       //    params.append('AdPageId',this.conteid);//内容页id
       //    params.append('AdPlateId',this.plateid);//板块id
       //    params.append('Title',this.txtTitle);//标题
       //    params.append('LinkUrl',this.titleLink);//标题链接
       //    params.append('Path',val.link);//图片链接路径
       //    params.append('SortNum',1);//序号
       //   //编辑替换
       //   if(this.info_id>0){
       //     params.append('info_id',this.info_id);//序号
       //     this.$axios.post(updateadPlateinfo, params).then(res => {
       //       this.print()
       //       this.checkedCities = [] //图片库选中按钮取消选中
       //       this.interlinkageLink = '' // 图片路径清空
       //       this.serialNumber = '' //图片序号清空
       //       this.txtTitle = '' //文字标题清空
       //       this.titleLink = ''//文字链接标题清空
       //       this.dialogImgregualte = false
       //     })
       //   }else{//添加
       //     this.$axios.post(advplateinfo, params).then(res => {
       //       this.print()
       //       this.checkedCities = [] //图片库选中按钮取消选中
       //       this.interlinkageLink = '' // 图片路径清空
       //       this.serialNumber = '' //图片序号清空
       //       this.txtTitle = '' //文字标题清空
       //       this.titleLink = ''//文字链接标题清空
       //       this.dialogImgregualte = false
       //     })
       //   }
 
 
 
       },
          // 图片库显示全部图片
       all2(){
         if (this.checkedc) {
           this.currentPage0 = 'all'
           this.imglibrary(1, this.scmCompanyid2, this.userName2,this.info_id)
         } else {
           this.currentPage0 = 10
           this.imglibrary(1, this.scmCompanyid2, this.userName2,this.info_id)
         }
       },
       //图片库
       imglibrary(e, companyid2, name2,type){
         this.dialogImgregualte = true
         if(type&&type>0){
           this.info_id = type
         }else {
           this.info_id = 0
         }
 
       let params = new URLSearchParams();
         if (e) {
           params.append('page_number', e)
         } else {
           params.append('page_number', this.currentPage2)
         }
         params.append('page_size',this.currentPage0);
         params.append('file_type', 'photo');
         params.append('companyid', sessionStorage.getItem('companyid'));
       //   this.$axios.get(backbrary,{
       //     params
       //   }).then(res =>{
       //    console.log(res.data);
       //     let arr = []
       //     let listlist = []
       //     this.currentPage5 = Number(res.data[0]['PageNums'])
       //     console.log(this.currentPage5);
       //     res.data[0].pagedata.forEach(item =>{
       //         arr.push(item)
       //         listlist.push(item.link)
       //     })
       //     this.srcList = arr
       //     this.raylist = listlist
       //   })
         params.append('year', this.yearData)
          params.append('month', this.monthData)
          params.append('page_size', this.currentPage0)
          params.append('page_number', this.currentPage2)
          this.$axios.get(showPictures, {params}).then(res => {
             console.log(res.data);
             let arr = []
           let listlist = []
           this.currentPage5 = Number(res.data['page_total'])
           res.data.page_data.forEach(item =>{
               arr.push(item)
               listlist.push(item.imgUrl)
           })
           console.log(arr);
           this.srcList = arr
           this.raylist = listlist
          })
        //   this.$axios.get(showPictures,{
       //     params
       //   }).then(res =>{
       //     let arr = []
       //     let listlist = []
       //     this.currentPage5 = Number(res.data[0]['PageNums'])
       //     res.data[0].pagedata.forEach(item =>{
       //         arr.push(item)
       //         listlist.push(item.link)
       //     })
       //     this.srcList = arr
       //     this.raylist = listlist
       //   })
 
        
       },
      
       //图片库分页
       currentChangeHandle2(val){
         console.log(val);
         this.currentPage2 = val
         this.checkedCities = []
         this.imglibrary(this.currentPage2, this.scmCompanyid2, this.userName2,this.info_id)
 
       },
          //   取消按钮
       callOff(){
        this.dialogGoods = false
        //   this.dialogImgregualte = false
        //   this.checkedCities = []
        //   this.interlinkage = ''
       },
    //   图片库分组信息
       getfileData(){
          this.$axios.get(getFilegroupview,{
         }).then(res =>{
          this.FileGroupList = res.data
         })
       },
       // 新增分组
       CreateGroup(){
          this.$axios.post(CreateGroup,{
         }).then(res =>{
          console.log(res);
          if(res.status == 200){
             this.$message({
               message: '创建成功',
               type: 'success',
               duration: 1000,
               showClose: true,
             });
             this.getfileData()
          }
         })
       },
       // 查询
       getresult(){
          this.setBtnClicks()
       },
       // 确定
       confirmin(){
        this.$emit('shopData',this.newData)
        this.dialogGoods = false
        //   console.log(this.pitchimg);
        //   this.interlinkageLink = this.pitchimg.imgUrl
        //   let params = new URLSearchParams();
        //   params.append('UserId',sessionStorage.getItem('user_id'));//创建人id
        //   params.append('AdPageId',this.conteid);//内容页id
        //   params.append('AdPlateId',this.plateid);//板块id
        //   params.append('Title',this.txtTitle);//标题
        //   params.append('LinkUrl',this.titleLink);//标题链接
        //   params.append('Path',this.pitchimg.imgUrl);//图片链接路径
        //   params.append('SortNum',1);//序号
        //  //编辑替换
        //  if(this.info_id>0){
        //    params.append('info_id',this.info_id);//序号
        //    this.$axios.post(updateadPlateinfo, params).then(res => {
        //      this.print()
        //      this.checkedCities = [] //图片库选中按钮取消选中
        //      this.interlinkageLink = '' // 图片路径清空
        //      this.serialNumber = '' //图片序号清空
        //      this.txtTitle = '' //文字标题清空
        //      this.titleLink = ''//文字链接标题清空
        //      this.dialogImgregualte = false
        //    })
        //  }else{//添加
        //    this.$axios.post(advplateinfo, params).then(res => {
        //      this.print()
        //      this.checkedCities = [] //图片库选中按钮取消选中
        //      this.interlinkageLink = '' // 图片路径清空
        //      this.serialNumber = '' //图片序号清空
        //      this.txtTitle = '' //文字标题清空
        //      this.titleLink = ''//文字链接标题清空
        //      this.dialogImgregualte = false
        //    })
        //  }
          // this.dialogImgregualte = false
       },
       selectClick(val,type) {
          if(type == 'year'){
             this.yearData = val
          }else{
             this.monthData = val
          }
       },
       // 鼠标移入
          setBtn(item,index){
             if(index){
                this.current = index //图标显示隐藏
                this.setBtn1 = true
             }
          },
       // 鼠标移除
       setBtnLeave(item,index){
          this.setBtn1 = false
          this.current = null
       },
       // 选择分组
       setBtnClick(item,index){
          this.currentPage0 = 20,
          this.currentPage2 = 1,
          this.allName = item.name
          if(item.name == '全部'){
             this.imglibrary()
          }else{
          this.groupid = item.FileGroup_id
          this.setBtnClicks()
          }
         
       },
       setBtnClicks(){
          if(this.allName == '全部'){
          let params = new URLSearchParams();
          params.append('year', this.yearData)
          params.append('month', this.monthData)
          params.append('page_size', this.currentPage0)
          params.append('page_number', this.currentPage2)
          this.$axios.get(showPictures, {params}).then(res => {
             let arr = []
           let listlist = []
           this.currentPage5 = Number(res.data['page_total'])
           res.data.page_data.forEach(item =>{
               arr.push(item)
               listlist.push(item.imgUrl)
           })
           this.srcList = arr
           this.raylist = listlist
          })
          }else{
             let params = new URLSearchParams();
          params.append('groupid', this.groupid)
          params.append('year', this.yearData)
          params.append('month', this.monthData)
          params.append('page_size', this.currentPage0)
          params.append('page_number', this.currentPage2)
          this.$axios.get(showPictures, {params}).then(res => {
             let arr = []
           let listlist = []
           this.currentPage5 = Number(res.data['page_total'])
           res.data.page_data.forEach(item =>{
               arr.push(item)
               listlist.push(item.imgUrl)
           })
           this.srcList = arr
           this.raylist = listlist
          })
          }
       
       },
      setBtns(index){
      var listData = this.FileGroupList 
      var helpFlag = this.FileGroupList[index].helpFlag // 先用一个变量接收一个原来的状态值
      listData.forEach((item) => {  //循环已经把所有的状态值清空了
         item.helpFlag = false
     })
     listData[index].helpFlag = !helpFlag
     this.FileGroupList = listData  
    },
       getinputDATA(val){
          console.log(val,'val');
           this.filename = val
     },
       // 编辑
       edit(item,index){
           var listData = this.FileGroupList 
           var edit1 = this.FileGroupList[index].edit1 // 先用一个变量接收一个原来的状态值
          if(this.confirmBtn == '编辑'){
          this.filename = item.name
           this.confirmBtn = '确定'
           this.cancelBtn = '取消'
           this.el_icon_edit = 'el-icon-circle-check'
           this.el_icon_delete = 'el-icon-circle-close'
           this.edit_state = '#409eff'
           this.delete_state = '#409eff '
          listData.forEach((item) => {  //循环已经把所有的状态值清空了
              item.edit1 = false
          })
            listData[index].edit1 = !edit1
            this.FileGroupList = listData  
            
          }else{
          let params = new URLSearchParams();
          params.append('id', this.groupid)
          params.append('name',this.filename)
          params.append('is_delete', '0')
          this.$axios.post(amendGroup, params).then(res => {
             if(res.data.status == 200){
                this.$message({
               message: '修改成功',
               type: 'success',
               duration: 1000,
               showClose: true,
             });
          }
          this.getfileData()
             
          })
             listData.forEach((item) => {  //循环已经把所有的状态值清空了
              item.edit1 = false
          })
          listData.forEach((item) => {  //循环已经把所有的状态值清空了
         item.helpFlag = false
     })
          this.FileGroupList = listData  
          // this.edit1 = true
          // this.setBtn2 = false
           this.confirmBtn = '编辑'
           this.cancelBtn = '删除'
           this.el_icon_edit = 'el-icon-edit'
           this.el_icon_delete = 'el-icon-delete'
           this.edit_state = '#409eff'
           this.delete_state = '#cf1010 '
          }
       },
       //删除
       del(item,index){
           var listData = this.FileGroupList 
           var edit1 = this.FileGroupList[index].edit1 // 先用一个变量接收一个原来的状态值
          if(this.cancelBtn == '删除'){
             this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
         }).then(() => {
          let params = new URLSearchParams();
          params.append('id', this.groupid)
          params.append('is_delete', '1')
          this.$axios.post(amendGroup, params).then(res => {
             console.log(res.data);
             if(res.data == 'ok'){
                this.$message({
                type: 'success',
                message: '删除成功!'
             });
             }
             this.getfileData()
             this.imglibrary()
             })
             
          }).catch(() => {
             this.$message({
                type: 'info',
                message: '已取消删除'
             });          
          });
             } else{
             this.confirmBtn = '编辑'
             this.cancelBtn = '删除'
             listData.forEach((item) => {  //循环已经把所有的状态值清空了
                item.edit1 = false
             })
             listData.forEach((item) => {  //循环已经把所有的状态值清空了
          item.helpFlag = false
          })
          this.FileGroupList = listData  
          }
       },
            //上传本地图片
     uploadAction(file){
       let fd = new FormData();
       fd.append('file', file.file); //传文件
       fd.append('groupid', this.groupid)
       fd.append('p_type', '产品图片')
       this.$axios.post(uploadPictures, fd).then(res => {
         if(res.status == 200){
          this.$message({
               message: '上传成功',
               type: 'success',
               duration: 1000,
               showClose: true,
             });
         }
         if(this.allName == '全部'){
          this.imglibrary()
         }else{
          this.setBtnClicks()
         }
         
       })
     },
     handleinformationSuccess(res, file) {
       },
       // 删除图片
       delImg(){
          console.log(this.isChecks);
             this.$confirm('是否删除该图片, 是否继续?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
          }).then(() => {
               if(this.checkedImg){
          let params = new URLSearchParams();
          params.append('ImgId', this.checkedCities.join())
          this.$axios.post(allPictures,params).then(res => {
             if(res.status == 200){
                this.$message({
             type: 'success',
             message: '删除成功!'
           });
             }
          if(this.allName == '全部'){
             this.imglibrary()
          }else{
             this.checkedImg = false
             this.setBtnClicks()     
         }
               
         });
          }else{
             let params = new URLSearchParams();
             params.append('groupid', this.groupid)
             params.append('id', this.pitchimg.id)
             params.append('is_delete', '1')
             this.$axios.post(amendPictures,params).then(res => {
                if(res.status == 200){
                   this.$message({
                type: 'success',
                message: '删除成功!'
             });
                }
                this.setBtnClicks()
             })
          }
          }).catch(() => {
             this.$message({
                type: 'info',
                message: '已取消删除'
             });          
          });
       },
       // 多选
       isCheck(val){
          console.log(this.checkedImg,val);
          // this.isChecks = val
          this.srcList.forEach(item =>{
             if(val){
                this.checkedCities.push(item.id)
             }else{
                this.checkedCities = []
             }
       //   this.checkedCities = val ? item.id : [];
          })
          // this.checkedCities = val ? this.srcList : [];
          this.isIndeterminate = false;
          // this.checkedImg = false;
          // console.log(this.srcList);
       }
       // 确定
       // confirm(){
       //    this.edit1 = true
       //    this.setBtn2 = false
       //    this.setBtn3 = false
       // },
       // // 取消
       // cancel(){
       //    this.edit1 = true
       //    this.setBtn2 = false
       //    this.setBtn3 = false
       // }
       // avc(val){
       //    console.log(val);
       // }
       // handleOpen(key, keyPath) {
       //   console.log(key, keyPath);
       // },
       // handleClose(key, keyPath) {
       //   console.log(key, keyPath);
       // }
      },
    };
  </script>
  <style scoped>
  .avatar-uploader .el-upload {
     border: 1px dashed #d9d9d9;
     border-radius: 6px;
     cursor: pointer;
     position: relative;
     overflow: hidden;
   }
   .avatar-uploader .el-upload:hover {
     border-color: #409EFF;
   }
   .avatar-uploader-icon {
     font-size: 28px;
     color: #8c939d;
     width:274px;
     height: 268px;
     line-height: 268px;
     text-align: center;
   }
   .avatar {
     width:274px;
     height: 268px;
     display: block;
   }
    /* 保存按钮 */
    .save{
       margin-left: 20px;
    }
    .box{
       display: flex;
       align-items: center;
    }
 /* 图片链接 */
  .ImageLinks{
    display: flex;
    align-items: center;
    margin: 0 20px;
  }
  /* 选择商品 */
  .boxGoods{
    display: flex;
    align-items: center;
  }
  .inquire{
    margin-left: 20px;
  }
 .el-input {
     width: 300px;
   }
   /* 图片设置 */
   .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
   }
 
   .button {
     padding: 0;
     float: right;
   }
 
   .image {
     width: 100%;
     display: block;
   }
 
   /* .clearfix:before,
   .clearfix:after {
       display: table;
       content: "";
   }
 
   .clearfix:after {
       clear: both
   } */
   /* 图片库 */
   .boxUpload{
   width: 60%;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   /* justify-content: space-between; */
 }
 .boxUploads{
   overflow-y: scroll;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   /* justify-content: space-between; */
 }
 .demo-image__preview{
     position: relative;
     margin-right: 10px;
     /* margin-bottom: 10px; */
   }
  .checksty{
     position: absolute;
     top: 0;
     right: 0;
   }
   .imgName{
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    text-align: center;
    height: 30px;
    line-height: 30px;
    color: #fff;
    font-size: 12px;
    overflow: hidden;
   }
   .inptbox{
     display: flex;
     align-items: center;
    }
    .inptbox .inpt{
     width:100%;
    }
    .btn{
     display: flex;
     justify-content: space-between;
    }
    .el-col-4 {
     margin-bottom: 20px;
    }
    .bxofrom{
       display:flex;
       flex-wrap: wrap;
       align-items: center;
    }
    .elfrom{
       width: 320px;
       padding-bottom: 10px;
       margin-right: 50px;
       margin-bottom: 20px;
       display: flex;
       flex-direction: column;
       align-items: center;
       background-color: #ffffff;
       box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
       border-radius: 4px;
    }
    .txtbtn{
       width: 320px;
       margin-top: 10px;
       display: flex;
       justify-content: space-around;
    }
  .inpimg{
       width: 90px;
       /* height: 20px; */
    }
   .head{
    display: flex;
    justify-content: space-between;
    align-items: center;
   }
   .line{
    border: 1px solid #d9d9d9;
   }
   /deep/ .el-input__suffix{
    display: none;
   }
   /deep/ .el-input--suffix .el-input__inner{
    height: 30px;
    border: none;
  }
  .set_foot{
    display: flex;
    justify-content: space-between;
    padding: 5px 15px;
    cursor: pointer;
    background: #fff;
  }
  /deep/ .el-submenu [class^=el-icon-]{
    font-size: 16px;
    margin: 0;
  }
  /deep/ .el-submenu .el-menu-item{
    padding: 0px;
  }
  .el-menu-vertical-demo{
    background: #d9d9d9;
  }
  .el-menu-item-group__title{
    padding: 0 !important;
   }
   .menuItem{
    color:#303133;
   }
  .left_seach{
    height: 33px;
    border: 1px solid #d9d9d9;
  }
   .search{
   width: 55px;
   border: none;
   }
   .upload{
    display: flex;
   }
   .content{
    display: flex;
    height: 360px;
    margin-top:20px;
    border-top: 1px solid #d9dadd;
    padding: 0;
   }
   .leftMenu{
    width: 200px;
    border-right: 1px solid #d9dadd;
    /* overflow: hidden; */
   }
   .increases{
    width: 200px;
    height: 100%;
    overflow-y: scroll;
    background:#d9dadd;
   }
   .increase{
    padding: 10px;
    border-bottom: 1px solid #d9d9d9;
    cursor: pointer;
   }
   .ico{
    position: relative;
    left: 18px;
    top: 2px;
    color:#3296fa;
    font-size: 20px;
   }
 
   .masterPic{
    padding: 20px;
   }
   .footers{
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-top: 40px;
   }
   .dialog-footer{
    display: flex;
    justify-content: center;
   }
   /deep/ .el-submenu .el-menu{
    background: #d9d9d9 !important;
   }
   /deep/ .el-menu-item-group__title{
    display: none !important;
   }
   .el-submenu{
    background: #d9d9d9 !important;
   }
  .el-menu-item:hover{  
   background: #fff !important;   
 }  
  .el-menu-item.is-active {  
    background: #fff !important;   
 }
 /deep/ .el-menu-item{
    padding-left: 10px !important;
  }
   
   /* .el-input__suffix{
    height: 0px !important;
    right: none !important;
   } */
 
  </style>
  <style>
  .el-col-offset-1:nth-child(6){
    margin-left: 0px;
 }
 </style>
 


// WEBPACK FOOTER //
// src/views/shopList.vue